import {jsonRequest, isDefined, POST} from "./helpers";

export const postAutoApproveRoles = async (roles) => {
  if (!isDefined(roles)) throw new Error("Roles Required");
  const data = {roles};
  return await jsonRequest(POST, "Config/AutoApprovalRoles", {
    body: JSON.stringify(data),
  });
};

export const postTranslationIsActive = async (translationIsActive) => {
  if (!isDefined(translationIsActive)) throw new Error("Translation is Active Required");
  const data = {translationIsActive};
  return await jsonRequest(POST, "Config/TranslationIsActive", {
    body: JSON.stringify(data),
  });
};
